import React from 'react';
import { Radio } from 'semantic-ui-react';

//Create a docstring for the component
/**
 * RadioButton is a reusable component that renders a radio button.
 * @param {string} label - The label of the radio button.
 * @param {string} value - The value of the radio button.
 * @param {boolean} checked - The checked state of the radio button.
 * @param {function} onChange - The function that handles the change state of the radio button.
 * @param {string} className - The class name of the radio button.
 **/

const RadioButton = ({ label, value, checked, onChange, className,disabled }) => {
  return (
    <Radio
      label={label}
      value={value}
      checked={checked}
      onChange={onChange}
      className={className}
      disabled={disabled}
      
    />
  );
};

export default RadioButton;
